module.exports = __webpack_public_path__ + "static/media/stringaFESR_2014-2020.f5fefd0d.png";